export default __webpack_public_path__ + "static/media/avatarclient.e03cde7d.svg";